module.exports = __webpack_public_path__ + "static/media/30OIOS5.98503dfc.jpg";